import { Action } from '../Action';
import { v4 as uuid } from 'uuid';
import { getDefaultActionSchema } from '../../aiAgent/utils/AgentUtils';
export class ActionViewModel extends Action {
    static $inject = ['init'];
    constructor(init) {
        super();
        this.$id = uuid();
        this.$typeOfContent = '';
        this.$description = '';
        this.$inputSchema = getDefaultActionSchema();
        Object.assign(this, init);
    }
}
